import update from 'react-addons-update';

export function moveItem({ dragItem, pathFrom, pathTo }, extraProps = {}) {
  const { childrenProp } = this.props;
  let { items } = this.state;

  // the remove action might affect the next position,
  // so update next coordinates accordingly
  const realPathTo = this.getRealNextPath(pathFrom, pathTo);

  const removePath = this.getSplicePath(pathFrom, {
    numToRemove: 1,
    childrenProp,
  });

  const insertPath = this.getSplicePath(realPathTo, {
    numToRemove: 0,
    itemsToInsert: [dragItem],
    childrenProp,
  });

  items = update(items, removePath);
  items = update(items, insertPath);

  this.setState({
    items,
    isDirty: true,
    ...extraProps,
  });
}
